import React, { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import {
  Button, Carousel, CarouselItem,
} from 'reactstrap';
import { Link } from 'react-router-dom';

import { APIintegrations } from '../../../api/Integrations';

import { userIsAdmin, userIsManager } from '../../../helpers/Auth';
import { getIntegrationsURLPath } from '../../../helpers/Integrations';

import IntegrateButton from './IntegrateButton';

const OnboardingIntegrate = () => {
  const intl = useIntl();

  const [animating, setAnimating] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [integrations, setIntegrations] = useState([]);

  const showIntegrations = ['googledrive', 'dropbox', 'figma'];
  const showIntegrationsVariants = ['box', 'slack', 'mailchimp', 'webflow', 'adobe-photoshop'];

  const integrationsToShow = integrations.filter(i => showIntegrations.includes(i.id))
    .sort((a, b) => showIntegrations.indexOf(a.id) - showIntegrations.indexOf(b.id));

  const integrationsVariantsToShow = integrations
    .filter(i => showIntegrationsVariants.includes(i.id))
    .sort(
      (a, b) => showIntegrationsVariants.indexOf(a.id) - showIntegrationsVariants.indexOf(b.id),
    );

  const next = useCallback(() => {
    if (animating) return;
    const nextIndex = activeIndex === integrationsToShow.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  }, [activeIndex, animating, integrationsToShow.length]);

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? integrationsToShow.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (!animating) {
        next();
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [animating, next]);

  useEffect(() => {
    APIintegrations().then((response) => {
      setIntegrations(response);
    });
  }, []);

  if (!(userIsAdmin() || userIsManager())) {
    return null;
  }

  return (

    <div className="onboarding-card">
      <div className="onboarding-card-header">
        {intl.formatMessage({ defaultMessage: 'Browse integrations' })}
      </div>
      <div>
        <div className="onboarding-step-integrate-integrations-wrapper">
          <Carousel
            activeIndex={activeIndex}
            next={next}
            previous={previous}
          >
            {integrationsToShow.map(integration => (
              <CarouselItem
                key={integration.id}
                onMouseLeave={() => setAnimating(true)}
                onMouseEnter={() => setAnimating(false)}
              >
                <div className="onboarding-step-integrate-integrations-element">
                  <div className="onboarding-step-integrate-integrations-element-logo">
                    <img
                      id={`integration-logo-${integration.id}`}
                      src={integration.logo_url}
                      alt={integration.name}
                    />
                  </div>
                  <span>{integration.name}</span>
                  <IntegrateButton
                    integration={integration}
                    disconnecting={false}
                    handleDisconnect={() => { }}
                  />
                </div>
              </CarouselItem>
            ))}
          </Carousel>
          <div className="onboarding-step-integrate-integrations-element onboarding-step-integrate-integrations-element-variants">
            <div className="onboarding-step-integrate-integrations-element-logos-wrapper">
              {integrationsVariantsToShow.map(integration => (
                <div key={integration.id} className="onboarding-step-integrate-integrations-element-logo">
                  <img
                    id={`integration-logo-variant-${integration.id}`}
                    src={integration.logo_url}
                    alt={integration.name}
                  />
                </div>
              ))}
            </div>
            <Button
              tag={Link}
              to={getIntegrationsURLPath()}
            >
              {intl.formatMessage({ defaultMessage: 'See more' })}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingIntegrate;
